
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 17.5c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L15.8.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L1.7 17.2c-.2.2-.4.3-.7.3z","fill":"#000"}}),_c('path',{attrs:{"d":"M16.5 17.5c-.3 0-.5-.1-.7-.3L.3 1.7C-.1 1.3-.1.7.3.3c.4-.4 1-.4 1.4 0l15.5 15.5c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3z","fill":"#000"}})])
          )
        }
      }
    